import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { FreemiumService } from '../freemium.service';
import { PersonData } from '../freemiumParams';
import * as _ from 'underscore';
import { GaEventsService } from 'src/app/_services/ga-events.service';


@Component({
    selector: 'app-webbtree-freemium-profile',
    templateUrl: './webbtree-freemium-profile.component.html',
    styleUrls: ['./webbtree-freemium-profile.component.scss'],
    standalone: false
})
export class WebbtreeFreemiumProfileComponent implements OnInit {

  subscriptions: Subscription[] = [];
  candidateList: any[] =[];
  @Output() updateProfileEvent: EventEmitter<any> = new EventEmitter();

  constructor(private freemiumService: FreemiumService, private gaService: GaEventsService) { }

  ngOnInit() {
    const recCandidateDataSub = this.freemiumService.recFreemiunCandidateDataEvent.subscribe(data => this.getFreemiumRecommendData(data));
    this.subscriptions.push(recCandidateDataSub);
   /**
     * GA tracking for Insights page visit
     */
    this.gaService.trackButtonClick('Profile_Page_View');
  }

  getFreemiumRecommendData(data: PersonData) {
    this.candidateList = data.candidateList;
    this.candidateList = this.candidateList.map(res => {
      res.highlightsInfo = res.curatedtalentpooltags.length > 0 ? _.uniq(res.curatedtalentpooltags, 'displayname'): [];
      res.profiles = res.profiles.length > 0 ? _.uniq(res.profiles, 'network'): [];
      return res;
    })

  }

  highlightInfo(data: string, type: 'current_jobtitle' | 'past_jobtitle' | 'location' | 'skill' | 'currentjobtitle' | 'currentcompany' | 'pastcompany', candidate: any) {
    let keywords: any
    if(data) {
     const dataForHighlight = data.trim().toLowerCase().replace(/<.*?>'/g, '').replace(/'/g, "");
    // const datafind = keywords.filter(x=>dataForHighlight.includes(x.replace(/[()*"]/g, '').toLowerCase().trim()));
    // if(datafind.length > 0) {
          let highlightedData: any= data;
          let highlightFound: any;
          switch (type) {
            case 'current_jobtitle':
              {
               if(candidate && candidate?.highlight && candidate?.highlight['experience.title.name'] ) {
                const highlightFound = candidate && candidate?.highlight && candidate?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               } if(candidate && candidate?.highlight && candidate?.highlight['experience.title.name.keyword']) {
                const highlightFound = candidate && candidate?.highlight && candidate?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               } if(candidate && candidate?.highlight && candidate?.highlight['job_title.keyword']) {
                const highlightFound = candidate && candidate?.highlight && candidate?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               } if(candidate && candidate?.highlight && candidate?.highlight['job_title']) {
                const highlightFound = candidate && candidate?.highlight && candidate?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
               }
             }
             break;

             case 'location':
              {
                if(candidate && candidate?.highlight && candidate?.highlight['location_name'] ) {
                  const highlightFound = candidate && candidate?.highlight && candidate?.highlight['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                } if(candidate && candidate?.highlight && candidate?.highlight['location_locality'] ) {
                  const highlightFound = candidate && candidate?.highlight && candidate?.highlight['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                } if(candidate && candidate?.highlight && candidate?.highlight['location_name.keyword'] ) {
                  const highlightFound = candidate && candidate?.highlight && candidate?.highlight['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                }

              }
              break;
            case 'skill':
              {
                if(candidate && candidate?.highlight && candidate?.highlight['skills'] ) {
                  const highlightFound = candidate && candidate?.highlight && candidate?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                } if(candidate && candidate?.highlight && candidate?.highlight['skills.keyword'] ) {
                  const highlightFound = candidate && candidate?.highlight && candidate?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                }
             }
              break;

          }

          return highlightedData;
      }

    //  }



    return data;
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  startFreeTrial(eventName: string) {
    this.updateProfileEvent.emit({ status: 'scroll', eventName: eventName });

  }

}
